import React, { useState } from 'react';
import dayjs from 'dayjs';
import { twMerge } from 'tailwind-merge';

const BaseCalendarWeek = ({ loadData = {}, setDate, disableDates = false, className, value }) => {
    const [currentWeekStart, setCurrentWeekStart] = useState(dayjs(value).startOf('week').add(1, 'day'));

    const [selectedDay, setSelectedDay] = useState(dayjs(value).format('YYYY-MM-DD'));

    const handlePrevWeek = () => {
        setCurrentWeekStart((prev) => prev.subtract(1, 'week'));
    };

    const handleNextWeek = () => {
        setCurrentWeekStart((prev) => prev.add(1, 'week'));
    };

    const isDateDisabled = (date) => disableDates;

    const handleDateClick = (day) => {
        const formattedDate = day.format('YYYY-MM-DD');
        setSelectedDay(formattedDate);
        setDate(day.toDate());
    };

    const renderWeekDays = () => {
        const days = [];
        for (let i = 0; i < 7; i++) {
            const day = currentWeekStart.add(i, 'day');
            const isDisabled = isDateDisabled(day);
            const dayMeetings = loadData[day.format('YYYY-MM-DD')] || 0;

            let extraClassName = '';
            if (dayMeetings >= 1 && dayMeetings <= 3) {
                extraClassName = 'bg-theme1-success text-theme1-white';
            } else if (dayMeetings >= 4 && dayMeetings <= 5) {
                extraClassName = 'bg-theme1-warning text-theme1-white';
            } else if (dayMeetings > 5) {
                extraClassName = 'bg-theme1-primary text-theme1-white';
            }

            const isSelected = day.format('YYYY-MM-DD') === selectedDay;

            days.push(
                <td key={day.format('YYYY-MM-DD')} aria-label={day.format('YYYY-MM-DD')} className='p-datepicker-day'>
                    <span
                        className={twMerge(
                            'p-datepicker-daylabel text-theme1-dark bg-transparent',
                            isDisabled ? 'p-disabled opacity-50' : '',
                            isSelected ? 'p-highlight' : '',
                            extraClassName
                        )}
                        aria-selected={isSelected ? 'true' : 'false'}
                        aria-disabled={isDisabled}
                    >
                        <div
                            className={twMerge(
                                'w-full h-full flex items-center justify-center',
                                isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
                            )}
                            onClick={() => !isDisabled && handleDateClick(day)}
                        >
                            {day.format('D')}
                        </div>
                    </span>
                </td>
            );
        }
        return days;
    };

    return (
        <div className={twMerge('p-calendar p-component p-inputwrapper p-inputwrapper-filled', className)}>
            <div className='p-datepicker p-component p-datepicker-inline' style={{ width: '532px' }}>
                <div className='p-datepicker-group-container'>
                    <div className='p-datepicker-group'>
                        <div className='p-datepicker-header'>
                            <button
                                type='button'
                                className='p-datepicker-prev'
                                aria-label='Previous Week'
                                onClick={handlePrevWeek}
                            >
                                <svg
                                    width='24'
                                    height='24'
                                    viewBox='0 0 32 32'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                    className='stroke-theme1-text1'
                                >
                                    <path
                                        d='M20 25.3333L10.6667 16L20 6.66667'
                                        strokeWidth='2'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                </svg>
                            </button>
                            <div className='p-datepicker-title'>
                                <span className='font-bold'>
                                    {currentWeekStart.format('MMM D')} -{' '}
                                    {currentWeekStart.add(6, 'day').format('MMM D, YYYY')}
                                </span>
                            </div>
                            <button
                                type='button'
                                className='p-datepicker-next'
                                aria-label='Next Week'
                                onClick={handleNextWeek}
                            >
                                <svg
                                    width='24'
                                    height='24'
                                    viewBox='0 0 32 32'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                    className='stroke-theme1-text1'
                                >
                                    <path
                                        d='M12 6.66666L21.3333 16L12 25.3333'
                                        strokeWidth='2'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                </svg>
                            </button>
                        </div>
                        <div className='p-datepicker-calendar-container'>
                            <table className='p-datepicker-calendar'>
                                <thead>
                                    <tr>
                                        <th scope='col'>
                                            <span>Mo</span>
                                        </th>
                                        <th scope='col'>
                                            <span>Tu</span>
                                        </th>
                                        <th scope='col'>
                                            <span>We</span>
                                        </th>
                                        <th scope='col'>
                                            <span>Th</span>
                                        </th>
                                        <th scope='col'>
                                            <span>Fr</span>
                                        </th>
                                        <th scope='col'>
                                            <span>Sa</span>
                                        </th>
                                        <th scope='col'>
                                            <span>Su</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>{renderWeekDays()}</tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BaseCalendarWeek;
